import { useState } from 'react'
import { useDebounce } from 'use-debounce'
import { useAfterEffect } from 'hooks/useAfterEffect'

import TextField from '@mui/material/TextField'
import { TextFieldProps } from '@mui/material/TextField'

export type DebouncedTextFieldProps = TextFieldProps & {
  debounceTime?: number
  value: string
  onChange: (a: { target: { value: string } }) => void
}

export default function DebouncedTextField({ onChange, value: initialValue, debounceTime, ...props }: DebouncedTextFieldProps) {
  const [value, setValue] = useState(initialValue)
  const [debouncedValue] = useDebounce(value, debounceTime || 500)

  useAfterEffect(() => {
    onChange({target: {value: debouncedValue}})
  }, [debouncedValue])
  return <TextField {...props} value={value} onChange={event => setValue(event.target.value)}/>
}
